export default __webpack_public_path__ + "static/media/logo.9ec8cb65.svg";